import React from 'react';
import { injectIntl } from 'react-intl';
import { LayoutWithStepper } from 'layouts';
import {
  PageContentWrapper, PaymentDetail, FooterAction,
} from 'components';
import apiRequest from 'shared/services/api';
import { connect } from 'react-redux';
import selectors from 'shared/store/selectors';
// import axios from 'axios';
import { get } from 'lodash';
import utils from 'shared/helpers/utils';
import { PATH } from 'shared/constant';
import { toast } from 'react-toastify';
import { applicantAction } from 'shared/store/actions';

// const source = axios.CancelToken.source();

function PaymentFail({ intl, history, token, product, onUpdateHistory }) {
  const [paymentData, setPaymentData] = React.useState([]);
  // const abortController = new AbortController();
  const search = history.location?.search;
  // const details = [
  //   { label: intl.formatMessage({ id: 'payment.investedAmt.label' }), value: 'KWD 1,000' },
  //   { label: intl.formatMessage({ id: 'payment.id' }), value: '100201927384634224' },
  //   { label: intl.formatMessage({ id: 'payment.date' }), value: '2019-09-30 11:05:16' },
  // ];

  React.useEffect(() => {
    const queryStr = new URLSearchParams(search);
    const getData = queryStr.get('data');
    const parseData = async (data) => {
      try {
        const res = await apiRequest.parsePaymentResult(token, data, product);
        const resData = res.response;
        const details = [
          { label: intl.formatMessage({ id: 'payment.investedAmt.label' }), value: `${get(resData, 'variable3')} ${utils.formatNumberToDecimal(get(resData, 'amount'))}` },
          { label: intl.formatMessage({ id: 'payment.id' }), value: get(resData, 'paymentId') },
          { label: intl.formatMessage({ id: 'payment.date' }), value: get(resData, 'paidOn') },
        ];
        setPaymentData(details);

        // record history on MO
        const code = 'NW-PMT-FAI';
        const codeI18n = 'nw.markaz.middle_office.action_type.payment_failed';
        onUpdateHistory(code, codeI18n);
      } catch (err) {
        toast.error('Oops, error parsing data.');
      }
    };

    if (getData) parseData(getData);

    // return () => {
    //   // source.cancel();
    //   abortController.abort();
    // };
  }, [search, intl, token, product, onUpdateHistory]);

  return (
    <PageContentWrapper isWithPadding>
      <div className="content-container content-container--withPadding">
        {/* <p className="content-container__para">{intl.formatMessage({ id: 'payment.desc' })}</p> */}
        <PaymentDetail
          title={intl.formatMessage({ id: 'payment.unsuccess' })}
          data={paymentData}
          isDisabled={false}
        />
      </div>

      <FooterAction
        isSingleButton
        rightButton={intl.formatMessage({ id: 'payment.backToPayment' })}
        isDisabled={false}
        onRightButtonClick={() => history.push(PATH.PAYMENT)}
      />
    </PageContentWrapper>
  );
}

const mapStateToProps = state => ({
  token: selectors.getToken(state),
  product: selectors.getProduct(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(PaymentFail)));
